var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgJobIcon = function SvgJobIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 38.5h14c7.035 0 8.294-2.818 8.662-6.248l1.313-14c.472-4.27-.753-7.752-8.226-7.752h-17.5c-7.472 0-8.697 3.482-8.225 7.753l1.313 14c.367 3.43 1.627 6.247 8.662 6.247ZM14 10.5V9.1c0-3.097 0-5.6 5.6-5.6h2.8C28 3.5 28 6.003 28 9.1v1.4",
    stroke: "#203040",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 22.75v1.785C24.5 26.442 24.483 28 21 28c-3.465 0-3.5-1.54-3.5-3.448V22.75c0-1.75 0-1.75 1.75-1.75h3.5c1.75 0 1.75 0 1.75 1.75ZM37.888 19.25A28.848 28.848 0 0 1 24.5 24.535M4.585 19.723c3.937 2.695 8.382 4.322 12.915 4.83",
    stroke: "#203040",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgJobIcon;